<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <div class="leftSection">
            <div class="header-title wrapper-content__main font-weight__bold">
              Văn bản chờ tiếp nhận
            </div>
          </div>
        </template>
      </headerTemplate>
    </template>
    <template #view>
      <div class="view">
        <listTemplate :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <subHeader>
              <template #content>
                <div >
                  <el-button
                    size="medium"
                    type="success"
                    class="createNew"
                    @click="openCreateDocDialog"
                  >
                    <div class="flex-row flex__center">
                      <i class="fas fa-file-plus"></i>
                      <span>THÊM MỚI</span>
                    </div>
                  </el-button>
                </div>
                <div class=" margin-left-10" >
                  <el-button
                    size="medium"
                    type="success"
                    class="createNew"
                    @click="isOpenMultiScanDialogCreate = true"
                  >
                    <div class="flex-row flex__center">
                      <i class="fas fa-search"></i>
                      <span>&nbsp;&nbsp;SCAN</span>
                    </div>
                  </el-button>
                </div>
                <div class=" margin-left-10">
                  <!--                hoang xuất kêt quả tìm kiếm -->
                  <el-tooltip class="item" effect="dark" content="Kết xuất kết quả tìm kiếm" placement="top-end">
                    <el-button
                      size="medium"
                      @click="chosenFileType"
                      type="primary">
                      <div class="flex-row flex__center">
                        <i class="fas fa-file-export"></i>
                        <span>&nbsp;KẾT XUẤT</span>
                      </div>
                    </el-button>
                  </el-tooltip>
                </div>
                <searchTemplate
                  :keyword="keyword"
                  @simpleSearch="simpleSearch"
                  @search="isOpenAdvanceSearchDialog = true"
                >
                  <template #quickFilter>
<!--                    <div-->
<!--                      class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large"-->
<!--                    >-->
<!--                      <span class="label-input width__auto">Ngày đến</span>-->
<!--                      <el-date-picker-->
<!--                        v-model="incomingDateRange"-->
<!--                        type="daterange"-->
<!--                        format="dd/MM/yyyy"-->
<!--                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"-->
<!--                        :picker-options="dateQuickFilterOption"-->
<!--                        range-separator="_"-->
<!--                        start-placeholder="_"-->
<!--                        end-placeholder="_"-->
<!--                        align="right"-->
<!--                        :clearable="false"-->
<!--                        @change="filterByIncomingDateRange"-->
<!--                      ></el-date-picker>-->
<!--                    </div>-->

                    <div class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large">
                      <span class="label-input width__auto"
                      >Ngày đến
                      </span>
                      <span class="label-input width__auto">Từ ngày:</span>
                      <el-date-picker
                        v-model="fromIncomingDate"
                        type="date"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        placeholder="Chọn ngày bắt đầu"
                        align="right"
                        :clearable="false"
                        @change="filterByIncomingDateRange"
                      ></el-date-picker>
                    </div>

                    <div class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large">
                      <span class="label-input width__auto">Đến ngày:</span>
                      <el-date-picker
                        v-model="toIncomingDate"
                        type="date"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        placeholder="Chọn ngày kết thúc"
                        align="right"
                        :clearable="false"
                        @change="filterByIncomingDateRange"
                      ></el-date-picker>
                    </div>

                  </template>
                  <template #advance>
                    <chotiepnhan-advance-search-dialog
                      :isOpen="isOpenAdvanceSearchDialog"
                      :form="advanceSearchForm"
                      v-if="isEnableAdvanceSearchDialog"
                      @dialogClosed="isEnableAdvanceSearchDialog = false"
                      @closeDialog="isOpenAdvanceSearchDialog = false"
                      @doSearch="advanceSearch"
                      @searchLockedRoleDocIn="searchLockedRoleDocIn"
                    />
                  </template>
                </searchTemplate>
              </template>
            </subHeader>
          </template>

          <template #body>
            <div class="list">
              <!-- header-title -->
              <div class="header-title flex-row flex__between margin-bottom-10">
                <div class="leftSection flex-row flex__left">
                  <div class="theTitle theTitle__lv5">
                    <span class="stt margin-left-10">STT</span>
                  </div>
                  <div
                    class="theTitle theTitle__lv1 flex-row flex__left clickable"
                    @click="doSort('quote')"
                  >
                    Trích yếu
                    <sort-caret :order="order" :sort="sort" :field="'quote'"/>

                  </div>
                </div>
                <div class="rightSection flex-row flex__right">
                  <div
                    class="theTitle theTitle__lv2 flex-row flex__right clickable"
                    @click="doSort('forwardDeptName')"
                  >
                    Nơi gửi
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'forwardDeptName'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv2 flex-row flex__right clickable"
                    @click="doSort('publisherName')"
                  >
                    Đơn vị phát hành
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'publisherName'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__right clickable"
                    @click="doSort('docDate')"
                  >
                    Ngày văn bản
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'docDate'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__right clickable"
                    @click="doSort('incomingDate')"
                  >
                    Ngày đến
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'incomingDate'"
                    />
                  </div>

                  <div
                    class="theTitle flex-row flex__right clickable"
                    style="width: 160px; padding-right: 10px"
                    @click="doSort('status')"
                  >
                    Trạng thái
                    <sort-caret :order="order" :sort="sort" :field="'status'"/>
                  </div>
                </div>
              </div>
              <!-- list-docs -->
              <VuePerfectScrollbar
                class="scroll-area"
                :settings="perfectScrollbarSetting"
                infinite-wrapper
              >
                <div class="list-docs">
                  <div
                    v-for="(item, $itemIndex) in filteredIncomingTuChoiDoc"
                    v-bind:key="$itemIndex"
                    :class="[
                        'item flex-row flex__between',
                        !item.isSeen ? 'is-seen' : ''
                      ]"
                    @click="viewDetail(item)"
                  >
                    <div class="leftSection flex-row flex__left">
                      <div class="theTitle__lv5">
                        <div class="flex-row flex__left">
                          <div class="section-check">
                            <span class="stt flex-row flex__center">{{
                              $itemIndex + 1
                            }}</span>
                          </div>

                          <i class="fas fa-file color__silver"></i>

                        </div>
                      </div>
                      <div class="theTitle__lv1">
                        <div class="title-docs flex-col flex__left">
                          <div
                            class="tt_1 clickable"
                            v-bind:class="textBold(item)"
                          >
                            {{ item.quote }}

                          </div>
                          <div class="tt_2 flex-row flex__left">

                            <span v-if="item.docCode"
                            >{{ item.docCode }}&nbsp;&nbsp;</span
                            >
                            <el-tag
                              v-if="item.docTypeName"
                              size="mini"
                              :class="['priority', 'lv3']"
                            >{{ item.docTypeName }}
                            </el-tag
                            >
                            <el-tag
                              v-if="isShowPriority(item.priorityId)"
                              size="mini"
                              :class="[
                                'priority',
                                getPiorityClass(item.priorityId)
                              ]"
                            >
                              <i class="fas fa-bolt"></i>
                              <span>{{ item.priorityName }}</span>
                            </el-tag>

                            <span>
                               <el-tooltip
                                 content="Văn bản điện tử"
                                 placement="top"
                                 effect="dark"
                                 v-if="isVbDienTu(item)"
                               >
                                 <div class="eIcon">e</div>
                               </el-tooltip>
                            </span>
                            <span>
                               <el-tooltip
                                 content="Đã ban hành bản giấy"
                                 placement="top"
                                 effect="dark"
                                 v-if="item.isBanHanhBanGiay"
                               >
                                 <div class="eIcon">p</div>
                               </el-tooltip>
                            </span>
                            <span>
                               <el-tooltip
                                 content="Không có tài liệu đính kèm"
                                 placement="top"
                                 effect="dark"
                                 v-if="item.isNotFileDinhKem"
                               >
                                 <div class="eIcon">p</div>
                               </el-tooltip>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightSection flex-row flex__right">
                      <div
                        class="theTitle__lv2 flex-row flex__right font-size__small"
                      >
                        <div class="flex-row flex__right txt-left">
                          {{
                            (item.publisherNameDetail ? item.publisherNameDetail + " " : "") +
                            (item.forwardDeptName || item.publisherName  || item.insidePublisherName || item.outsidePublisherName)
                          ||"-"
                          }}
                        </div>
                      </div>
                      <div
                        class="theTitle__lv2 flex-row flex__right font-size__small"
                      >
                        <div class="flex-row flex__right txt-left">
                          {{
                            (item.publisherNameDetail ? item.publisherNameDetail + " " : "") +
                            (item.publisherName ? item.publisherName + " " : "-") ||
                            item.outsidePublisherName ||
                            item.insidePublisherName ||
                            "-"
                          }}
                        </div>
                      </div>

                      <div
                        class="theTitle__lv3 flex-row flex__right font-size__small"
                      >
                        <div class="flex-row flex__right txt-right">
                          <i
                            class="cellIcon color__silver fas fa-file-import"
                          ></i>
                          {{
                          item.docDate
                          | dateFormatter({
                          nullValue: "-",
                          dateFormat: "DD/MM/YYYY"
                          })
                          }}
                        </div>
                      </div>

                      <div
                        class="theTitle__lv3 flex-row flex__right font-size__small"
                      >
                        <div class="flex-row flex__right txt-left">
                          <i class="cellIcon color__silver fas fa-clock"></i>
                          {{
                          item.incomingDate | dateFormatter({ nullValue: "-" })
                          }}
                        </div>
                      </div>

                      <div
                        class=" flex-row flex__right font-size__small"
                        style="width: 160px; padding-right: 10px"
                      >
                        <div class="flex-row flex__right txt-left">
                          <div
                            class="status-doc flex-row flex__left font-size__medium"
                          >
                            <span>
                              {{ getStatus(item) }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="theQuickAction flex-row flex__right" v-if="isEnableDelete(item)">
                        <el-tooltip
                          content="Xóa văn bản"
                          placement="top"
                          v-if="isEnableDelete(item)"
                        >
                          <i
                            class="action-icon bgAmbient__red clickable fas fa-trash"
                            @click.stop="delete_(item)"
                          ></i>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>

                  <infinite-loading
                    ref="infiniteLoading"
                    spinner="spiral"
                    @infinite="infiniteHandler"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results">Không có dữ liệu</div>
                  </infinite-loading>
                </div>
              </VuePerfectScrollbar>
            </div>
          </template>
        </listTemplate>
      </div>

      <create-doc-in-dialog
        :isOpen="isOpenDialogCreate"
        :id="selectedDocId"
        :customRequiredFields="customRequiredFields"
        v-if="isEnableDialogCreate"
        @dialogClosed="isEnableDialogCreate = false"
        @closeDialog="closeDialog"
        @success="createDocSuccess"
        @deleteSuccess="doWithDocSuccess"
        @rejectSuccess="doWithDocSuccess"
        @cxlSuccess="cxlSuccess"
      />
      <multi-scan-doc-in-dialog
        :isOpen="isOpenMultiScanDialogCreate"
        v-if="isEnableMultiScanDialogCreate"
        @closed="isEnableMultiScanDialogCreate = false"
        @closeDialog="isOpenMultiScanDialogCreate = false"
        @success="createMultiScanDocSuccess"
      />
      <!--      hoang chosen file type-->
      <chosen-file-type-dialog
        v-if="isOpenChosenFileTypeDialog"
        @closeDialog="isOpenChosenFileTypeDialog= false"
        @exportResult="exportResult"
        :is-open="true">
      </chosen-file-type-dialog>
    </template>
  </listTemplate>
</template>
<script>
  import InfiniteLoading from "vue-infinite-loading";
  import incomingDocService from "../../services/incomingDocService";
  import dateFormatter from "../../filters/dateFormatter";
  import constants from "../../constants";
  import utils from "../../services/utils";
  import listTemplate from "../common/list";
  import {EventBus} from "../../event-bus.js";
  import ChotiepnhanAdvanceSearchDialog from "./components/chotiepnhan-advance-search-dialog";
  import vbDenVTMixin from "./vbDenVTMixin";
  import CreateDocInDialog from "./components/CreateDialog";
  import h from "../../services/h";
  import MultiScanDocInDialog from "./multi-scan-doc-in-dialog";
  import chosenFileTypeDialog from "../doc-out/chosenFileTypeDialog";
  import outgoingDocService from "../../services/outgoingDocService";

  export default {

    mixins: [vbDenVTMixin],

    components: {
      chosenFileTypeDialog,
      MultiScanDocInDialog,
      CreateDocInDialog,
      ChotiepnhanAdvanceSearchDialog,
      InfiniteLoading,
      listTemplate,
      headerTemplate: () => import("../../components/header/main-header.vue"),
      searchTemplate: () => import("../common/search.vue"),
      VuePerfectScrollbar: () => import("vue-perfect-scrollbar"),
      subHeader: () => import("../../components/main/sub-header.vue"),
      SortCaret: () => import("../doc-out/SortCaret")
    },

    filters: {dateFormatter},

    data() {
      return {
        isOpenChosenFileTypeDialog:false,
        sortList:[],
        dateQuickFilterOption: utils.getDefaultDateQuickFilterOption(),
        isOpenAdvanceSearchDialog: false,
        isEnableAdvanceSearchDialog: false,
        isOpenMultiScanDialogCreate:false,
        isEnableMultiScanDialogCreate:false,
        isOpenDialogCreate: false,
        isEnableDialogCreate: false,
        perfectScrollbarSetting: {maxScrollbarLength: 350},

        incomingDocs: [],
        filteredIncomingTuChoiDoc: [],
        selectedDocId: null,

        page: 0,
        size: 10,
        sort: null,
        order: null,
        keyword: null,

        createDocFlag: 0, //cờ để phân biệt là mở popup từ dialog create ?!

        customRequiredFields:[],
      };
    },

    computed: {
      userDeptRoleId() {
        return this.$route.params.userDeptRoleId;
      },
      currentRoute() {
        return this.$route.path.split("/")[3];
      },
    },

    watch: {
      isOpenDialogCreate(newValue) {
        if (newValue) {
          this.applyDocCodeRequiredField();
          this.isEnableDialogCreate = newValue
        } else {
          if (this.createDocFlag > 0) this.createDocFlag--;
        }
      },
      isOpenMultiScanDialogCreate(newValue) {
        newValue && (this.isEnableMultiScanDialogCreate = newValue);
      },

      isOpenAdvanceSearchDialog(newValue) {
        newValue && (this.isEnableAdvanceSearchDialog = newValue);
      },

      isEnableDialogCreate(newValue) {
        if (!newValue) {
          this.selectedDocId = null;
          /**
           * tiếp tục mở dialog để thực hiện nhập liệu tiếp nhận văn bản
           */
          if (this.createDocFlag > 0) {
            console.log("tiếp tục mở dialog để thực hiện nhập liệu tiếp nhận văn bản");
            this.$nextTick(() => this.isOpenDialogCreate = true);
          }
        }
      }
    },

    created() {
      this.initQuery();
      this.setDefaultDocDateRange();
      this.filterByIncomingDateRange();
    },

    mounted() {
      EventBus.$on(this.currentRoute, options => {
        this.doSearch();
      });
      this.openTiepNhanDialog();
    },

    methods: {
      isVbDienTu(item){
        if(item.eFlag&&item.eFlag==='1'){
          return true;
        }else {
          return false;
        }
      },
      chosenFileType(){
        this.isOpenChosenFileTypeDialog = true
      },
      exportResult(item) {
        this.isOpenChosenFileTypeDialog = false
        this.exportSearchResult(item,'VB_DEN_CHO_TIEP_NHAN')
      },
      exportSearchResult(fileType,name){
        let pageable;
        if(this.sortList&&this.sortList.length>0){

          let sort=[];
          h.each(this.sortList,(item)=>{
            sort.push(item);
          })
          pageable = {
            page: 0,
            size: 1000,
            sort: sort
          };
        }else {
          pageable = {
            page: 0,
            size: 1000,
            sort: [this.sort, this.order].join(",")
          };
        }
        let params = utils.merge(this.advanceSearchForm, pageable)
        params.userId=this.$store.getters.userDeptRole.userId;
        params.deptId=this.$store.getters.userDeptRole.deptId;
        params.roleId=this.$store.getters.userDeptRole.roleId;
        params.positionId = this.$store.getters.userDeptRole.positionId;
        params.fileType = fileType
        params.name = name

        let baseServiceURL = constants.BASE_SERVICE_URL;
        let reportUrl = constants.IN_PHIEU.SEARCH_RESULT_VB_DEN_CHO_TIEP_NHAN;
        window.open(
          `${baseServiceURL}${reportUrl}?${utils.serialize(params)}`
        );


        // return incomingDocService
        //   .listChoTiepNhan2(this.advanceSearchForm, pageable)
        //   .then(response => {
        //     let items = response.data;
        //     items && (this.incomingDocs.push(...items));
        //     return items;
        //   });
      },
      createMultiScanDocSuccess() {
        this.isOpenMultiScanDialogCreate = false;
        this.message("Thông báo", "Scan văn bản thành công", "success", 2000)
        this.doSearch();
      },
      openCreateDocDialog() {

        this.isOpenDialogCreate = true;
        this.createDocFlag++;
      },

      /**
       * khi click vao notify (trong TH ban hanh van ban) > se redirect toi trang nay va thuc hien mo popup;
       */
      openTiepNhanDialog() {
        let docId = localStorage.getItem(constants.STORAGE_KEY.CHO_TIEP_NHAN_DOC_ID);
        if (docId) {
          this.isOpenDialogCreate = true;
          this.selectedDocId = docId;
          localStorage.removeItem(constants.STORAGE_KEY.CHO_TIEP_NHAN_DOC_ID);
        }
      },

      setDefaultDocDateRange() {
        const startDate = new Date(new Date().getFullYear(), 0, 1);
        this.fromIncomingDate = startDate;
      },

      filterByIncomingDateRange(event) {
        const a = this.isValidDate(this.fromIncomingDate);
        const b = this.isValidDate(this.toIncomingDate);

        if ((this.fromIncomingDate === null || !a) && (this.toIncomingDate === null || b)) {
          this.fromIncomingDate = new Date(new Date().getFullYear(), 0, 1);
        } else if ((this.toIncomingDate === null || !b) && (this.fromIncomingDate === null || a)) {
          this.toIncomingDate = new Date(new Date().getFullYear(), 11, 31);
        } else if (this.fromIncomingDate > this.toIncomingDate) {
          this.fromIncomingDate = new Date(new Date().getFullYear(), 0, 1);
          this.toIncomingDate = new Date(new Date().getFullYear(), 11, 31);
        }

        this.advanceSearchForm.fromIncomingDate = this.fromIncomingDate ? this.fromIncomingDate.getTime() : undefined;
        this.advanceSearchForm.toIncomingDate = this.toIncomingDate ? this.toIncomingDate.getTime() : undefined;
        this.doSearch();
      },

      isValidDate(date) {
        return date instanceof Date && !isNaN(date);
      },
      textBold(event) {
        if (event.hasOwnProperty("isRead")) {
          if (event.isRead === "seen") return "";
          else return "text-bold";
        } else return "";
      },

      getStatus(item) {
        let checkChuaVaoSo =
          item.isInBook === constants.INCOMING_DOC.DA_VAO_SO
            ? "Đã vào sổ"
            : "Chưa vào sổ";
        let checkStatus =
          item.status === constants.INCOMING_DOC_STATUS.TU_CHOI ? " - Từ chối" : "";
        return `${checkChuaVaoSo} ${checkStatus}`;
      },

      closeDialog() {
        this.isOpenDialogCreate = false;
      },

      isShowPriority(id) {
        return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) !== -1;
      },

      createDocSuccess() {
        this.createDocFlag++;
        this.doWithDocSuccess();
      },

      cxlSuccess() {
        this.createDocFlag++;
        this.doWithDocSuccess();
      },

      doWithDocSuccess() {
        this.isOpenDialogCreate = false;
        this.doSearch();
      },

      initQuery() {
        this.sort = this.$route.query.sort || "incomingDate";
        this.order = this.$route.query.order || "desc";
        this.advanceSearchForm = {
          keyword: this.$route.query.keyword || undefined,
          fromDocDate: this.$route.query.fromDocDate
            ? parseInt(this.$route.query.fromDocDate)
            : undefined,
          toDocDate: this.$route.query.toDocDate
            ? parseInt(this.$route.query.toDocDate)
            : undefined,
          fromIncomingDate: this.$route.query.fromIncomingDate
            ? parseInt(this.$route.query.fromIncomingDate)
            : undefined,
          toIncomingDate: this.$route.query.toIncomingDate
            ? parseInt(this.$route.query.toIncomingDate)
            : undefined,
          docCode: this.$route.query.docCode || undefined,
          quote: this.$route.query.quote || undefined,
          fileContent: this.$route.query.fileContent || undefined,
          docTypeId: this.$route.query.docTypeId || undefined,
          bookId: this.$route.query.bookId || undefined,
          publisherId: this.$route.query.publisherId || undefined,
          outsidePublisherName: this.$route.query.outsidePublisherName || undefined,
          insidePublisherName: this.$route.query.insidePublisherName || undefined
        };
        this.keyword = this.advanceSearchForm.keyword;
        this.initIncomingDateRange();
      },

      buildQuery() {
        return utils.merge(
          {sort: this.sort || "incomingDate", order: this.order || "desc"},
          this.advanceSearchForm
        );
      },

      simpleSearch(keyword) {
        this.keyword = this.advanceSearchForm.keyword = keyword;
        this.advanceSearchForm.docCode = undefined;
        this.advanceSearchForm.quote = undefined;
        this.advanceSearchForm.fileContent = undefined;
        this.advanceSearchForm.docTypeId = undefined;
        this.advanceSearchForm.bookId = undefined;
        this.advanceSearchForm.publisherId = undefined;
        this.advanceSearchForm.outsidePublisherName = undefined;
        this.advanceSearchForm.insidePublisherName = undefined;
        this.doSearch();
      },

      advanceSearch(event) {
        let advanceSearchForm = event.advanceSearchForm;
        this.sortList=event.sortList;
        this.advanceSearchForm.keyword = undefined;
        this.keyword = null;
        this.advanceSearchForm.docCode = advanceSearchForm.docCode || undefined;
        this.advanceSearchForm.quote = advanceSearchForm.quote || undefined;
        this.advanceSearchForm.fileContent = advanceSearchForm.fileContent || undefined;
        this.advanceSearchForm.docTypeId = advanceSearchForm.docTypeId || undefined;
        this.advanceSearchForm.bookId = advanceSearchForm.bookId || undefined;
        this.advanceSearchForm.publisherId = advanceSearchForm.publisherId || undefined;
        this.advanceSearchForm.priorityId =advanceSearchForm.priorityId || undefined;
        this.advanceSearchForm.outsidePublisherName = advanceSearchForm.outsidePublisherName || undefined;
        this.advanceSearchForm.insidePublisherName = advanceSearchForm.insidePublisherName || undefined;
        this.advanceSearchForm.toIncomingDate = advanceSearchForm.toIncomingDate || undefined;
        this.advanceSearchForm.fromIncomingDate = advanceSearchForm.fromIncomingDate || undefined;
        this.advanceSearchForm.fromDocDate = advanceSearchForm.fromDocDate || undefined;
        this.advanceSearchForm.toDocDate = advanceSearchForm.toDocDate || undefined;
        this.advanceSearchForm.sortList = event.sortList || undefined;
        this.initIncomingDateRange();
        this.doSearch();
      },

      searchLockedRoleDocIn() {
        this.$router.push({
          name: "lockedRoleDocInIndex",
          params: this.params
        });
      },

      doSort(sort) {
        this.sort = sort;
        this.order =
          sort === this.sort ? (this.order === "asc" ? "desc" : "asc") : "asc";
        this.doSearch();
      },

      doSearch() {
        this.$router.replace({
          name: "vbChoTiepNhan",
          params: this.$route.params,
          query: this.buildQuery()
        });
        this.incomingDocs = [];
        this.filteredIncomingTuChoiDoc = [];
        this.page = 0;
        this.$nextTick(
          () =>
            this.$refs.infiniteLoading &&
            this.$refs.infiniteLoading.stateChanger.reset()
        );
      },

      infiniteHandler($state) {
        this.list().then(items => {
          this.page += 1;
          items && items.length ? $state.loaded() : $state.complete();
        });
      },

      async list() {
        let pageable;
        if (this.sortList && this.sortList.length > 0) {
          let sort = [];
          h.each(this.sortList, (item) => {
            sort.push(item);
          })
          pageable = {
            page: this.page,
            size: this.size,
            sort: sort
          };
        } else {
          pageable = {
            page: this.page,
            size: this.size,
            sort: [this.sort, this.order].join(",")
          };
        }

        // Cập nhật advanceSearchForm với userId
        // this.advanceSearchForm.userId = this.$store.getters.user.id;

        let items = [];

        await incomingDocService
          .listChoTiepNhan2(this.advanceSearchForm, pageable)
          .then(response => {
            items = response.data;
            items && (this.filteredIncomingTuChoiDoc.push(...items));
            let userId = this.$store.getters.user.id;
            for (let i = this.filteredIncomingTuChoiDoc.length - 1; i >= 0; i--) {
              //nếu là vb bị từ chối và không phải người tạo thì bị lọc
              if (this.filteredIncomingTuChoiDoc[i].status === constants.INCOMING_DOC_STATUS.TU_CHOI) {
                if (this.filteredIncomingTuChoiDoc[i].vbOutgoingDocId !== null) {
                  outgoingDocService
                    .findById(this.filteredIncomingTuChoiDoc[i].vbOutgoingDocId).then(res => {
                    let data = res.data;
                    if (userId !== data.creatorId) {
                      this.filteredIncomingTuChoiDoc.splice(i, 1)
                    }
                  })
                    .catch(() => {
                      this.filteredIncomingTuChoiDoc.splice(i, 1)
                    });
                }else{
                  if (userId !== this.filteredIncomingTuChoiDoc[i].creatorId){
                    this.filteredIncomingTuChoiDoc.splice(i, 1)
                  }
                }
              }
            }
          });
        return items;
      },

      markAsReadForVanThu(id) {
        return incomingDocService.markAsReadForVanThu(id).then(() => {
          EventBus.$emit('loadCounting', '');
        });
      },

      viewDetail(item) {
        item.isSeen = 1;

        this.markAsReadForVanThu(item.id).then(
          () => {
            if (!item.forwardIncomingDocId) {
              item.isRead = 1;
              this.isOpenDialogCreate = true;
              this.selectedDocId = item.id;
            } else {
              this.$router.push({
                name: "vbChoTiepNhanDetailEditable",
                params: {id: item.id}
              });
            }
          }
        )
      },
      isEnableDelete(item) {
        return (
          item &&
          item.creatorId === this.$store.getters.user.id &&
          this.$store.getters.userDeptRole.roleCode === constants.ROLE.CODE.VAN_THU
        );
      },

      delete_(item) {
        this.$confirm(
          `Bạn có muốn xóa văn bản "${item.quote}" ?`,
          "Thông báo",
          {
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Hủy bỏ",
            type: "warning"
          }
        ).then(() => {
          incomingDocService
            .deleteForVanThu(item.id)
            .then(respone => {
              this.$message({
                message: "Xóa thành công",
                type: "success",
                duration: 2000
              });
              EventBus.$emit('loadCounting', '');
              this.doSearch();
            })
            .catch(error => this.commonHandleRequestError(error));
        });
      },
      getPiorityClass(id) {
        return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) !== -1
          ? "lv1"
          : "lv4";
      },

      applyDocCodeRequiredField() {
        if(this.$store.getters.user.tenantCode === 'vinataba.com.vn' && this.$store.getters.userDeptRole.roleCode ==='vanthu')
        this.customRequiredFields.push('docCode');
      },
    }
  };
</script>
<style scoped>
  #searchBox {
    position: relative;
    width: 100%;
  }

  .advance-search {
    font-size: 17px;
    color: #005eb1;
    position: absolute;
    right: 5%;
    top: 50%;
    transform: translateY(-50%);
  }

  .icon-very__small {
    height: 14px;
    padding-top: 4px;
  }

  .icon-info {
    background-color: #f0c330;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    margin-top: -1px;
    margin-left: 2px;
  }
  .e-icon{
    color: #007aff;
    font-size: 17px;
    font-weight: 3;
    position: relative;
    top: -3px;
    display: inline;
  }

  .eIcon{
    border: solid 1px #007aff;
    border-radius: 2px;
    padding: 0px 3px;
    font-size: 11px;
    color: goldenrod;
    margin-left:2px;
  }

</style>



// WEBPACK FOOTER //
// src/views/doc-in/Index.vue